import English from "./en.png";
import French from "./fr.png";

export default {
  en: {
    label: "English",
    Icon: English
  },
  fr: {
    label: "Français",
    Icon: French
  }
};
